export const PRODUCT_BADGE_LABELS: Record<string, string> = {
  UNSPECIFIED: '',
  TYPE_TOP_SELLER_VENDOR: 'بیشترین فروش شما',
  TYPE_TOP_SELLER_AREA: 'پرفروش منطقه',
  TYPE_BOTTOM_SELLER_VENDOR: 'کمترین فروش شما',
  TYPE_BOTTOM_SELLER_AREA: 'کم‌فروش منطقه',
  UNFAIR_PRICE: 'قیمت غیر منصفانه'
};
